<template>
  <div class="list-view-widget p-15">
    <new-map-view
      :roleId="roleId"
      :permissions="permissions"
      @setMapData="setMapData"
      @viewRegistration="viewRegistration"
      @exportDocumentId="exportPopup"
    ></new-map-view>
    <registration-details-popup
      v-if="dashboardRecordsFlag"
      :dashboardRecordsFlag="dashboardRecordsFlag"
      :permissions="permissions"
      :dataRow="activeRegistration"
      @hidePopup="hidePopup"
      @dashboardWidgets="dashboardWidgets"
      :reportFlag="true"
    ></registration-details-popup>
    <permission-access-modal></permission-access-modal>
    <export-popup
      :documentId="documentId"
      @resetExportPopup="resetExportPopup"
      :mapData="mapData"
    ></export-popup>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>
<script>
// import cloneDeep from 'lodash/cloneDeep';
// import * as d3 from 'd3v4';
import $ from 'jquery';
import vSelect from '../../../UIComponents/TrackPlusSelect.vue';
import NewMapView from '../../../UIComponents/NewMapView.vue';
import registrationDetailsPopup from '../../../Registrations/RegistrationDetailsPopup.vue';
import Loader from '../../../UIComponents/Loader.vue';
import PermissionAccessModal from '../../../Common/PermissionAccessModal.vue';
import { getChartsDataOverView } from '../../../../apis/reports';
import { getRegistrationDetailsById } from '../../../../apis/registrations';
import constructRegistrationObject from '../../../../utils/registrationDetails';
import ExportPopup from '../../../Common/ExportPopup.vue';

export default {
  props: ['roleId', 'permissions'],
  data() {
    return {
      dashboardRecordsFlag: false,
      loaderStatus: false,
      errors: [],
      ViewCountryList: false,
      editFlag: '',
      activeRegistration: {},
      actualProductData: [],
      data: [],
      registrationdata: [],
      productList: [],
      dataProduct: [],
      dataMapProduct: [],
      mapProductList: [],
      registrationIdList: [],
      mapRegistrationIdList: [],
      productDropDownLabel: 'All',
      mapProductDropDownLabel: 'All',
      marginTitle: 0,
      mapData: [],
      mapDataloaded: false,
      country: '',
      countryList: [],
      disabledClrBtn: true,
      listView: false,
      isIslands: false,
      isExport: false,
      isProductSelected: false,
      isCountrySelected: false,
      isCheckedCounter: 0,
      worldMapId: 'worldMap',
      tablelistChartId: 'tableListChart',
      documentId: ''
    };
  },
  components: {
    PermissionAccessModal,
    Loader,
    registrationDetailsPopup,
    vSelect,
    ExportPopup,
    NewMapView
  },
  methods: {
    setMapData(mapData) {
      this.mapData = mapData;
    },
    exportPopup(id) {
      this.documentId = id;
      $('#exportPdfImg').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    resetExportPopup() {
      this.documentId = '';
      $('#exportPdfImg').modal('hide');
    },
    dashboardWidgets() {
      this.activeRegistration = {};
      this.dashboardRecordsFlag = false;
    },
    async viewRegistration(registrationId) {
      this.activeRegistration = {};
      this.dashboardRecordsFlag = true;
      if (this.permissions.indexOf('REG_TRACKER_RECORDS') === -1) {
        $('#permissionAccessModal').modal({
          backdrop: 'static',
          keyboard: false
        });
      } else {
        if (this.roleId === 4) {
          return;
        }
        this.loaderStatus = true;
        const selectedRegistration = await getRegistrationDetailsById(
          registrationId
        );
        this.loaderStatus = false;
        if (selectedRegistration && selectedRegistration.error) {
          this.$notify({
            clear: true,
            group: 'custom-notification'
          });
          this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Registration is not found!',
            group: 'custom-notification'
          });
        } else if (selectedRegistration) {
          this.activeRegistration =
            constructRegistrationObject(selectedRegistration);
          $('#registrationDetail').modal();
        }
      }
    },
    async getChartsDataOverView() {
      const data = await getChartsDataOverView();
      this.registrationCount = data.noOfRegistrations;
    },

    closeModal(e) {
      this.activeRegistration = {};
      if (this.editFlag) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      this.activeId = '';
      return true;
    },
    hidePopup(value) {
      this.editFlag = value;
    }
  },
  async created() {
    this.getChartsDataOverView();
  },
  mounted() {
    $('#registrationDetail').on('hide.bs.modal', this.closeModal);
  },
  beforeDestroy() {
    $('.tracker-map-tooltip').remove();
  }
};
</script>

<style lang="scss" scoped>
.list-view-widget {
  .list-title {
    position: relative;
    bottom: 2px;
    font-weight: $font-weight-400;
    font-size: $font-14;
    line-height: 36px;
    /* Emergo Dark Blue */
    color: $dark-black-alpha;
    margin-right: 8px;
    padding-top: 2px;
  }

  .map-controls-container {
    display: flex;
    .dropdown-container {
      display: flex;
      width: 60%;
      .products-container {
        display: flex;
        width: 50%;

        .products-dropdown {
          width: 80%;
        }
      }
      .country-container {
        display: flex;
        width: 50%;
        margin-left: 35px;

        .country-dropdown {
          width: 80%;
        }
      }
    }

    .btn-container {
      display: flex;
      width: 40%;
      justify-content: flex-end;

      .clear-button-wrapper {
        margin-right: 25px;
      }
      .export-container {
        display: flex;
        > div:first-child {
          margin-right: 25px;
        }
      }
    }
  }

  #tableListChart {
    .table {
      height: 410px;
      thead.background_fff {
        background: $deep-white;
        tr.table-title {
          font-weight: $font-weight-small;
          font-size: $font-24;
          line-height: 28px;
          color: $black;
          .country-border {
            border-bottom: 2px solid $deep-gray;
          }
          .expired-border {
            border-bottom: 2px solid #eb5757;
          }
          .expiring-soon-border {
            border-bottom: 2px solid #f2994a;
          }
          .pending-border {
            border-bottom: 2px solid #9b51e0;
          }
          .active-border {
            border-bottom: 2px solid #f2c94c;
          }
        }
      }
    }
  }
  .showMap {
    height: 520px;

    .custom-worldclassmap {
      text-align: center;
      padding-left: 0px;
    }
  }
  .islands-div {
    color: #606266;
    font-size: $font-12;
    padding: 25px 10px 10px 0px;
  }
  .txt-alg-rt {
    text-align: right;
  }
  .pl-60 {
    padding-left: 60px !important;
  }
  .pl-80 {
    padding-left: 80px !important;
  }

  .pl-8 {
    padding-left: 8px !important;
  }
  table,
  td {
    font-weight: $font-weight-small;
    font-size: $font-16;
  }

  table > tbody > tr {
    border-bottom: 0.5px solid $gray74;
    border-collapse: collapse;
  }
  .table > thead > tr > th {
    border-bottom: none;
    cursor: default;
  }
  tbody {
    max-height: 370px;
    display: block;
    overflow-y: auto;
    bottom: 10px;
  }
  thead,
  tr {
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  h1 {
    font-size: 1.5em;
    text-align: center;
    color: $tertiary;
    font-weight: lighter;
  }
}

@media screen and (max-width: 1024px) {
  .list-view-widget {
    .map-controls-container {
      .dropdown-container {
        .products-container {
          .products-dropdown {
            width: 80%;
            max-width: 182px;
          }
        }
        .country-container {
          display: flex;
          width: 50%;
          margin-left: 35px;

          .country-dropdown {
            width: 80%;
            max-width: 182px;
          }
        }
      }
    }
  }
}

@media (min-width: 1025px) and (max-width: 1300px) {
  .expiring-soon-border {
    display: table !important;
  }
}
@media only screen and (max-width: 1024px) {
  .list-view-widget {
    table {
      height: 410px !important;
    }
    tbody {
      height: 330px;
      overflow-y: auto;
    }
  }
}
@media only screen and (max-width: 767px) {
  .list-view-widget {
    .mt-xs-10 {
      margin-top: 10px !important;
    }
    .list-title {
      font-size: $font-22 !important;
    }
    .p-xs {
      padding: 0px !important;
      font-size: $font-14 !important;
    }
    .table > thead > tr > th {
      padding: 0px !important;
    }
    .table > tbody > tr > td {
      font-size: $font-12 !important;
      padding-left: 0px !important;
      text-align: center !important;
    }
    tbody {
      height: 310px !important;
      overflow-y: auto !important;
    }
  }
}

@media (min-width: 1200px) and (max-width: 1550px) {
  .list-title {
    padding-left: 0px;
  }
}
@media (min-width: 992px) and (max-width: 1200px) {
  .list-view-widget {
    .p-m-0 {
      padding: 0px !important;
    }
  }
}

@media (min-width: 768px) and (max-width: 992px) {
  .list-view-widget {
    .p-m-0 {
      padding: 0px !important;
    }
    .wd-110 {
      width: 105px;
    }
    .sm-pl-0 {
      padding-left: 0;
    }
  }
}

@media screen and (min-width: 1024px) {
  .wd-80 {
    width: 120px;
  }
}

@media screen and (max-width: 767px) {
  .list-view-widget {
    .wd-80 {
      width: 100%;
      max-width: 131px;
    }

    .map-controls-container {
      flex-direction: column;
      .dropdown-container {
        flex-direction: column;
        width: 100%;
        .products-container {
          width: 100%;
          flex-direction: column;
          .products-dropdown {
            width: 100%;
            max-width: unset;
          }
        }
        .country-container {
          margin-left: 0px;
          width: 100%;
          flex-direction: column;
          margin-top: 24px;

          .country-dropdown {
            width: 100%;
            max-width: unset;
          }
        }
      }

      .btn-container {
        display: flex;
        width: 100%;
        margin-top: 24px;

        .clear-button-wrapper {
          width: 100%;
          max-width: 131px;
        }
      }
    }
  }
}
</style>
